module.exports = __webpack_public_path__ + "static/media/mitsubishi-parking-selected.45901d3a.svg";